import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currencies: [],
};

export const currenciesSlice = createSlice({
  name: "currencies",
  initialState,
  reducers: {
    setCurrencies: (state, action) => {
      state.currencies = action.payload || [];
    },
  },
});

export const { setCurrencies } = currenciesSlice.actions;

export default currenciesSlice.reducer;
